import { render, staticRenderFns } from "./WhoIsNextApprover.vue?vue&type=template&id=33b714c4&scoped=true"
import script from "./WhoIsNextApprover.vue?vue&type=script&lang=js"
export * from "./WhoIsNextApprover.vue?vue&type=script&lang=js"
import style0 from "./WhoIsNextApprover.vue?vue&type=style&index=0&id=33b714c4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33b714c4",
  null
  
)

export default component.exports